import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { DotIndicator } from '@sololearnorg/sol';

import { SlLEContext } from '../../global-constants';
import { CurrentPageType } from '../../global-interface';
import { SlDataService } from '../../services/sl-data.service';
import { CourseLoaderSkeleton } from '../CourseLoaderSkeleton/CourseLoaderSkeleton';
import { CoursesLoader } from '../CoursesLoader/CoursesLoader';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './Loader.scss';

export function Loader(): JSX.Element {
  useStyles(s);
  const { loading$: loading, routeData$: routeData } = useContainerData(
    SlLEContext,
    SlDataService,
    ['loading$', 'routeData$'],
  );

  return (
    <>
      {loading?.fullScreen && (
        <div
          sl-test-data="smpLoaderFullScreen"
          className="sb-dotIndicator"
        >
          <DotIndicator className="loading-fullscreen" />
        </div>
      )}

      {loading?.courseTranslation && (
        <div
          sl-test-data="cmpLoaderCourseSkeleton"
          className="loading-course-skeleton"
        >
          <CourseLoaderSkeleton />
        </div>
      )}

      {loading?.prefetchAiWarningExperiment
        && (routeData.currentPage === CurrentPageType.LessonPage ? (
          <div className="sb-dotIndicator">
            <DotIndicator className="loading-fullscreen-transparent" />
          </div>
        ) : (
          <div
            sl-test-data="cmpLoaderCourseSkeleton"
            className="loading-course-skeleton"
          >
            <CourseLoaderSkeleton />
          </div>
        ))}

      {loading?.unlock && (
        <div sl-test-data="smpLoaderUnlock" className="sb-dotIndicator">
          <DotIndicator className="loading-unlock" />
        </div>
      )}

      {loading?.courseSkeleton && (
        <div
          sl-test-data="cmpLoaderCourseSkeleton"
          className="loading-course-skeleton"
        >
          <CourseLoaderSkeleton />
        </div>
      )}

      {loading?.getCourseCategories && (
        <div
          sl-test-data="cmpLoaderCourses"
          className="loading-courses"
        >
          <CoursesLoader />
        </div>
      )}
    </>
  );
}
